import {
	ADD_NEW_BRANDS,
	DELETE_BRANDS,
	GET_BRANDS
} from '../actions/types';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const defaultBrandState = {
	loading: false,
	data: false
}

export const brandsReducer = (state = defaultBrandState, action) => {

	switch(action.type){
		
		case `${DELETE_BRANDS}_${PENDING}`:
			return {
				loading: true,
				data:state.data
			}

		case `${DELETE_BRANDS}_${FULFILLED}`:
			return {
				loading: false,
				data:action.payload.data.brands
			}
	
		case `${DELETE_BRANDS}_${REJECTED}`:
			return {
				loading: false,
				data:state.data
			}

		/**
		 * ADD_NEW_BRANDS
		 */
		
		// case `${ADD_NEW_BRANDS}_${PENDING}`:
		// 	return {
		// 		loading: true,
		// 		data: state.data
		// 	}
		
		case `${ADD_NEW_BRANDS}`:
			return {
				loading: false,
				data: [...state.data, ...action.brands]
			}

		// case `${ADD_NEW_BRANDS}_${REJECTED}`:
		// 	return {
		// 		loading: false,
		// 		data: state.data
		// 	}

		/**
		 * GET_BRANDS
		 */

		case `${GET_BRANDS}_${PENDING}`:
			return {
				loading: true,
				data: false
			}
		
		case `${GET_BRANDS}_${FULFILLED}`:
			return {
				loading: false,
				data: action.payload.data.brands
			}

		case `${GET_BRANDS}_${REJECTED}`:
			return {
				loading: false,
				data: false
			}

	
		default:
			return state;

	}

}


// WEBPACK FOOTER //
// ./src/components/brands/reducers/index.js